<template>
  <div id="app">

    <SiteHeader v-if="!hideHeader"/>

    <main id="siteMain">
      <div class="container">
        <router-view/>
      </div>
    </main>

    <SiteFooter v-if="!hideHeader"/>
    <SignInPopup/>
  </div>
</template>

<script>
  import SiteFooter from './components/SiteFooter';
  import UserDataMixin from './mixins/userdata';
  import SiteHeader from './components/SiteHeader';
  import SignInPopup from './components/SignInPopup';

  export default {
    components: { SignInPopup, SiteHeader, SiteFooter },
    mixins: [ UserDataMixin ],
    beforeCreate() {
      const APP_INFO = this.$appInfo;

      // Initialize country array for v-select
      if ( APP_INFO.countries) {
        this.$store.commit('setCountriesArr', { countriesArr: APP_INFO.countries });
      }
      // Initialize user data
      if ( sessionStorage.getItem('user_data') ) {
        this.$store.commit('setUserData', {
          userData: JSON.parse(sessionStorage.getItem('user_data'))
        });
      } else if ( APP_INFO.user_data ) {
        this.$store.commit('setUserData', {
          userData: APP_INFO.user_data
        });
      }
      // Check if user has address data
      if ( !this.$store.state.userData.address )  this.$store.commit('setEmptyAddress');
      // Check if user has invoice data
      if ( !this.$store.state.userData.invoice )  this.$store.commit('setEmptyInvoice');
      // Check if user is logged
      if (this.$store.state.userData.name) this.$store.dispatch('signIn');

      if ( localStorage.getItem('landing_page_data') ) {
          let localStorageData = JSON.parse(localStorage.getItem('landing_page_data'));
          sessionStorage.setItem('activeSubscriptionStep', localStorageData.activeSubscriptionStep);
          sessionStorage.setItem('selectedPlan', JSON.stringify(localStorageData.selectedPlan));

          localStorage.removeItem('landing_page_data')
      }
          // Check for active step
      if (sessionStorage.getItem('activeSubscriptionStep')) {
        this.$store.state.activeStep = sessionStorage.getItem('activeSubscriptionStep');
      } else {
        this.$store.state.activeStep = 'SelectPlanStep'
      }

      // Check for selected plan
      if (sessionStorage.getItem('selectedPlan')) {
        this.$store.state.selectedPlan = JSON.parse(sessionStorage.getItem('selectedPlan'));
      }

      // Check for gift data
      if (sessionStorage.getItem('gift_data')) {
        this.$store.state.giftData = JSON.parse(sessionStorage.getItem('gift_data'));
      }

      // Check for coupon code
      if (sessionStorage.getItem('couponCode')) {
        this.$store.state.couponCode = sessionStorage.getItem('couponCode');
      }
    },
    computed: {
      hideHeader() {
        return this.$route.path === '/zmien_haslo/' || this.$route.path === '/resetuj_haslo/';
      }
    }
  }
</script>

<style lang="scss">
  @import
  'scss/variables',
  'scss/fonts',
  'scss/base',
  'scss/footer',
  'scss/utilities',
  'scss/spacings',
  'scss/forms',
  'scss/animations',
  'scss/get-members',
  'scss/vselect';

  #siteMain {
    padding-bottom: 100px;
    padding-top: 30px;
  }
</style>
